// extracted by mini-css-extract-plugin
module.exports = {"campaignLinks":"jgp-160R8"};